import {WithSummaryModel} from '../../../../common/entity/dto/plain/withSummary.model';
import {FormSummaryModel} from './formSummary.model';
import {FormDefinitionFormModel} from '../../../definition/form/api/entity/formDefinitionForm.model';
import {FormValueModel} from '../../value/api/entity/formValue.model';
import {ValueAndNameModel} from "../../../../common/model/valueAndName.model";

export class FormModel extends WithSummaryModel<FormSummaryModel> {
    formDefinition: FormDefinitionFormModel;
    values: FormValueModel[] = [];
    customValues: string[] = [];
}
